import { useState } from 'react';
import { Button } from '@/components/ui/button';
import api from '@/services/api';

interface Props {
  onAccepted: () => void;
}

export function AIDisclosureModal({ onAccepted }: Props) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleAccept = async () => {
    setLoading(true);
    setError(null);
    try {
      await api.acceptAIDisclosure();
      onAccepted();
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-dark-surface rounded-lg p-8 max-w-lg w-full">
        <h2 className="text-xl font-semibold text-ink dark:text-dark-text mb-4">
          How ZUPA generates your content
        </h2>
        <div className="space-y-3 text-sm text-steel-dark dark:text-dark-muted mb-6">
          <p>
            To generate social media posts for you, ZUPA sends the following information to
            Google's Gemini AI for processing:
          </p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Your prompt or content idea</li>
            <li>Your company information (name, industry, description)</li>
            <li>Your brand voice and writing samples</li>
            <li>Your target audience and persona profiles</li>
            <li>Your service/product descriptions</li>
          </ul>
          <p>
            This data is processed per Google's API terms and is <strong>not used to train
            Google's AI models</strong>.
          </p>
        </div>
        {error && <p className="text-error-text text-sm mb-2">{error}</p>}
        <Button onClick={handleAccept} disabled={loading} className="w-full bg-cargo text-cargo-ink hover:bg-cargo hover:opacity-90">
          {loading ? 'Processing...' : 'I understand'}
        </Button>
      </div>
    </div>
  );
}
